import { Accordion } from "../../components/accordion";
import { OrderSteps } from "../../components/orderSteps";

export const MainPlan = () => {
  return (
    <>
      <OrderSteps />
      <main>
        <Accordion />
      </main>
    </>
  );
};
